import VERSION from "../../config/Version";
import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import "../../index.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { optionSelected } from "../../app/features/counter/counterSlice";
import Registration from "../Templates/Registration";

function NavBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);
  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const [selectedOption, setSelectedOption] = useState("Option-1");
  const [showModal, setShowModal] = useState(false);
  const [exceedingItems, setExceedingItems] = useState([]);
  const [navigationPath, setNavigationPath] = useState("");
  const [navigationName, setNavigationName] = useState(null);
  const [showCustomerInfoForm, setShowCustomerInfoForm] = useState(false);

  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );

  const warningData = useSelector((state) => state.counter1.comparisonData);
  const selectedCameraQuantity = useSelector(
    (state) => state.counter1.selectedCameraQuantity
  );

  useEffect(() => {
    if (whichOption) {
      setSelectedOption(`Option-${whichOption}`);
    } else {
      dispatch(optionSelected("1"));
    }
  }, [whichOption]);

  const optionDescription = useSelector(
    (state) => state.counter1.optionDescription
  );

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    dispatch(optionSelected(option.split("-")[1]));
  };

  const optionButtons = [];
  if (totalNoOptions !== undefined) {
    for (let i = 1; i <= totalNoOptions; i++) {
      optionButtons.push(
        <Button
          key={`Option-${i}`}
          style={{ border: "none" }}
          variant="dark"
          className={`mt-3 ms-1 ${
            selectedOption === `Option-${i}` ? "bg-danger" : ""
          }`}
          onClick={() => handleOptionSelect(`Option-${i}`)}
        >
          Option-{i}
        </Button>
      );
    }
  }

  // Sets the current path in the setNavigationName when component renders
  // useEffect(() => {
  //   const currentPath = window.location.hash.replace("#", "");
  //   if (!navigationName) {
  //     setNavigationName(currentPath);
  //   }
  // }, []);

  const handleShow2 = (path) => {
    if (totalNoOptions === undefined) {
      navigate(path);
      return;
    }

    const currentPath = window.location.hash.replace("#", "");

    // Prevent showing the warning multiple times. Only display the warning when navigating to a different category.
    if (path !== currentPath) {
      const itemsToWarn = Object.entries(warningData).filter(([key, value]) => {
        if (value.navigationName === currentPath) {
          //Filtering the data from the object so that we show warning for last visited category only
          if (value.name === "poe") {
            return value.quantity < value.warning;
          } else {
            return value.quantity !== value.warning;
          }
        }
      });

      // setNavigationName(path);

      if (itemsToWarn.length > 0) {
        setExceedingItems(itemsToWarn);
        setShowModal(true);
        setNavigationPath(path); //Sets where to navigate
      } else {
        navigate(path);
      }
    }
  };

  //   const handleShow2 = (path) => {
  //     // if (totalNoOptions === undefined) return
  //     // if (path !== navigationPath && ) { // Prevent showing the warning multiple times. Only display the warning when navigating to a different category.
  //     const itemsToWarn = Object.entries(warningData).filter(([key, value]) => {
  //       if (value.navigationName === navigationName) { //Filtering the data from the object so that we show warning for last visited category only
  //         if (value.name === 'cameras' || value.name === 'nvr' || value.name === 'hardware' ||
  //           value.name === 'cables' || value.name === 'Labors' || value.name === 'special') {
  //           return value.quantity !== value.warning;
  //         } else {
  //           return value.quantity < value.warning;
  //         }

  //       }
  //     });

  //     setNavigationName(path);

  //     if (itemsToWarn.length > 0) {
  //       // const itemName = itemsToWarn[0][1].name;
  //       // const storedWarnings = JSON.parse(localStorage.getItem("warning")) || [];
  //       // if (storedWarnings.includes(itemName)) {
  //       //   navigate(path);
  //       // } else {
  //       //   storedWarnings.push(itemName);
  //       //   localStorage.setItem("warning", JSON.stringify(storedWarnings));
  //       setExceedingItems(itemsToWarn);
  //       setShowModal(true);
  //       setNavigationPath(path);
  //       // }
  //     } else {
  //       navigate(path);
  //     }
  //     // } else {
  //     //   setNavigationName(path);
  //     //   navigate(path);
  //     // }
  //   };
  // }

  return (
    <div className="navbar">
      {showCustomerInfoForm ? (
        <Registration
          setShowCustomerInfoForm={setShowCustomerInfoForm}
          showCustomerInfoForm={showCustomerInfoForm}
        />
      ) : null}
      <Navbar fixed="top" bg="dark" data-bs-theme="dark" expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/">
            Platinum CCTV
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Nav.Link
            // as={Link} to="/"
            onClick={() => handleShow2("/")}
          >
            Home
          </Nav.Link>

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              {areYouDealer === "Dealer Selected" ? (
                <Nav.Link as={Link} to="" className="dealearSelected">
                {areYouDealer}
              </Nav.Link>
              ) : null}
              <Nav.Link
                // as={Link} to="/nvr"
                onClick={() => handleShow2("/nvr")}
              >
                NVR
              </Nav.Link>
              <Nav.Link
                // as={Link} to="/cameras"
                onClick={() => handleShow2("/cameras")}
              >
                Cameras
              </Nav.Link>
              <Nav.Link
                // as={Link} to="/poe-switch"
                onClick={() => handleShow2("/poe-switch")}
              >
                PoE
              </Nav.Link>
              <Nav.Link
                // as={Link} to="/special"
                onClick={() => handleShow2("/special")}
              >
                Special
              </Nav.Link>
              <Nav.Link
                // as={Link} to="/hardware"
                onClick={() => handleShow2("/hardware")}
              >
                Hardware
              </Nav.Link>
              <Nav.Link
                // as={Link} to="/cabling"
                onClick={() => handleShow2("/cabling")}
              >
                Cables
              </Nav.Link>
              <Nav.Link
                // as={Link} to="/labor"
                onClick={() => handleShow2("/labor")}
              >
                Labor
              </Nav.Link>
            </Nav>

            <Nav>
              <Nav.Link
                // as={Link} to="/cart"
                onClick={() => handleShow2("/cart")}
              >
                Cart
              </Nav.Link>

              {/* Version comment */}
              <Nav.Link className="fst-italic fw-bold">
                <span style={{ color: "#999", fontSize: "12px" }}>
				{VERSION}
				</span>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container>
        <div className="optionBtnDiv">
          <div className="mt-5 d-flex">
            <button
              onClick={() => setShowCustomerInfoForm(!showCustomerInfoForm)}
              className="mt-3 btn btn-dark"
            >
              Customer Info
            </button>
            <div>{optionButtons}</div>
          </div>
        </div>
      </Container>

      <Modal show={showModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Warning: Quantity Exceeded</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ul>
            {exceedingItems.map(([key, value]) => (
              <li key={key}>
                {value.name === "nvr"
                  ? // ? `Licenses in option ${key} are not equal to Total Cameras Selected in option ${key}.`
                    `Option ${key} Camera Licenses not equal to Cameras`
                  : value.name === "cameras"
                  ? // ? `There are not the same number of Cameras in option ${key} for Total Cameras Selected.`
                    `Option ${key} Camera quantity does not match Required Cameras`
                  : value.name === "poe"
                  ? // ? `There are not enough PoE Ports for cameras in option ${key}.`
                    `Option ${key} Not Enough PoE Ports for Cameras Selected`
                  : value.name === "hardware"
                  ? `Option ${key} There are not enough Hardware selected for Total Drops`
                  : value.name === "cables"
                  ? // ? `There are less cameras and drops than cables in option ${key}.`
                    `Option ${key} Not enough Cables for total Drops`
                  : value.name === "special"
                  ? `Option ${key} Special Count is less than Drops`
                  : // : `Labor Count is less than Drops in option ${key}.`}
                    `Option ${key} Labor quantity does not match total Drops`}
              </li>
            ))}
          </ul>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              const currentPath = window.location.hash.replace("#", "");
              setExceedingItems([]); // Uncomment if needed
              setNavigationName(currentPath);
              setShowModal(false);
              setNavigationPath("");
            }}
          >
            Go back
          </Button>
          <Button
            variant="dark "
            onClick={() => {
              setShowModal(false);
              if (navigationPath) {
                navigate(navigationPath);
              }
            }}
          >
            Continue Anyway
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default NavBar;
